// Это работает, но типа не комильфо... :C

const $dropdown = $('.js-dropdown');
const Drop = {};

Drop.initDropdown = function () {
	$dropdown
		.on('click', function (e) {
			e.preventDefault();
			Drop.toggle($(this));
		});

	$(document).on('click', function (e) {
		if ($dropdown.hasClass('is-opened')) {
			let $container = $(`${$dropdown.data('target')}`);
			if (!$dropdown.is(e.target) && $dropdown.has(e.target).length === 0 && !$container.is(e.target) && $container.has(e.target).length === 0) {
				Drop.hideAll();
			}
		}
	});
};

Drop.toggle = function ($item) {
	let $container = $(`${$item.data('target')}`);

	if (!$item.hasClass('is-opened')) {
		$container
			.velocity('stop')
			.velocity('transition.fadeIn', {
				delay: 50,
				duration: 350,
				begin: function () {
					$item.addClass('is-opened');
					$container.addClass('is-opened');
				}
			});
	} else {
		$item
			.removeClass('is-opened');
		$container
			.removeClass('is-opened')
			.velocity('stop')
			.css({
				display: 'none',
				opacity: '0'
			});
	}
};

Drop.hideAll = function () {
	$.each($dropdown, function (index, el) {
		let $container = $(`${$(el).data('target')}`);

		$dropdown
			.removeClass('is-opened');
		$container
			.removeClass('is-opened')
			.velocity('stop')
			.css({
				display: 'none',
				opacity: '0'
			});
	});
};

Drop.initDropdown();





// WEBPACK FOOTER //
// ./frontend/components/dropdown/dropdown.js